import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getShuftiproWidgetUrl } from '../../_redux';
import { staticStyles } from './style';

const Shuftipro = ({ shuftiproWidgetUrl, getShuftiproWidgetUrl }) => {
  useEffect(() => {
    getShuftiproWidgetUrl();
  }, [getShuftiproWidgetUrl]);

  return shuftiproWidgetUrl ? (
    <div className="ShuftiproContainer">
      <iframe
        src={shuftiproWidgetUrl}
        id="shuftipro-iframe"
        title="shuftipro"
        allow="camera"
        frameBorder="0"
        width="100%"
        height="550px"
      />
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  ) : null;
};

Shuftipro.propTypes = {
  shuftiproWidgetUrl: PropTypes.string.isRequired,
  getShuftiproWidgetUrl: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    shuftiproWidgetUrl: state.client.kyc.shuftiproWidgetUrl,
  }),
  {
    getShuftiproWidgetUrl: () => getShuftiproWidgetUrl.request(),
  }
)(Shuftipro);
